export default "__VITE_ASSET__D_j6CsqA__"